import React from 'react';
import PropTypes from 'prop-types';
import iconSrc from '../../../../utils/iconSrc';
import { Wrapper, Icon, Message } from '../styles';
import { VisuallyHidden } from '../../../styled/accessibility';

const ErrorMessage = ({ id, message }) => (
  <Wrapper>
    <Icon src={iconSrc('alert-cross')} $error cacheRequests />
    <VisuallyHidden>Error: </VisuallyHidden>
    <Message id={id}>{message}</Message>
  </Wrapper>
);

ErrorMessage.propTypes = {
  id: PropTypes.string,
  message: PropTypes.string,
};

export default ErrorMessage;
